import { render } from "./WorkMaskExcel.vue?vue&type=template&id=4d96ba46&scoped=true"
import script from "./WorkMaskExcel.vue?vue&type=script&lang=js"
export * from "./WorkMaskExcel.vue?vue&type=script&lang=js"

import "./WorkMaskExcel.vue?vue&type=style&index=0&id=4d96ba46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d96ba46"]])

export default __exports__